import { Controller } from "@hotwired/stimulus"

// Drives the 3-way Access toggle (Payant / Gratuit / Sur invitation) in the
// unified course form (Création unifiée.html). Updates the hidden access_type
// input and reveals the matching conditional panel below.
export default class extends Controller {
  static targets = ["tab", "panel", "input"]
  static values  = { current: String }

  connect() {
    if (!this.currentValue) {
      const onTab = this.tabTargets.find(t => t.classList.contains("on"))
      this.currentValue = onTab?.dataset.key || "paid"
    }
    this.update(this.currentValue)
  }

  select(event) {
    event.preventDefault()
    const key = event.params.key
    if (!key || key === this.currentValue) return
    this.currentValue = key
    this.update(key)
  }

  update(key) {
    this.tabTargets.forEach(tab => {
      tab.classList.toggle("on", tab.dataset.key === key)
    })
    this.panelTargets.forEach(panel => {
      panel.classList.toggle("hidden", panel.dataset.key !== key)
    })
    if (this.hasInputTarget) {
      this.inputTarget.value = key
    }
  }
}
